"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebScoketState = void 0;
/**
 * ws的状态
 * 参考https://developer.mozilla.org/en-US/docs/Web/API/WebSocket
 */
var WebScoketState;
(function (WebScoketState) {
    WebScoketState[WebScoketState["CONNECTING"] = 0] = "CONNECTING";
    WebScoketState[WebScoketState["OPEN"] = 1] = "OPEN";
    WebScoketState[WebScoketState["CLOSING"] = 2] = "CLOSING";
    WebScoketState[WebScoketState["CLOSED"] = 3] = "CLOSED";
})(WebScoketState = exports.WebScoketState || (exports.WebScoketState = {}));
//# sourceMappingURL=WebScoketState.js.map